"use client";

import React from "react";
import Button from "@/components/ui/Button";
import DropdownMenu from "@/components/ui/DropdownMenu";
import { TAGS } from "@/content/data/tags";
import { capitalize, splitBreakpointProps } from "@/lib/utils";
import { useGalleryFilters } from "../provider";
import type { GalleryFilterProps } from "../types";

function GalleryFilter({ ...props }: GalleryFilterProps) {
  const { selectedTags, toggleTag } = useGalleryFilters();
  const { native } = splitBreakpointProps(props);

  return (
    <DropdownMenu data-slot="gallery-filter" {...native}>
      <DropdownMenu.Trigger asChild>
        <Button.Icon
          label="Select a filter"
          icon="chevron-down"
          variant="outline"
          orientation="right"
          aria-label="Select a filter"
        />
      </DropdownMenu.Trigger>

      <DropdownMenu.Content>
        <DropdownMenu.Label>Filters</DropdownMenu.Label>
        <DropdownMenu.Separator />

        {TAGS.map(({ key, label }) => (
          <DropdownMenu.CheckboxItem
            key={key}
            className="capitalize"
            checked={selectedTags.has(key)}
            onCheckedChange={(checked: boolean) => toggleTag(key, checked)}
          >
            {capitalize(label.toLowerCase())}
          </DropdownMenu.CheckboxItem>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
}

GalleryFilter.displayName = "Gallery.Filter";

export default GalleryFilter;
